import { http } from '../../../../api/http';
import * as XLSX from 'xlsx';
import type { ImportResult, ExcelPreviewData } from '../types/import.types';

const ENDPOINT = '/planilla/trabajador';

export class ImportTrabajadorService {
  static async uploadExcel(file: File): Promise<ImportResult> {
    const formData = new FormData();
    formData.append('file', file);

    const response = await http.post(`${ENDPOINT}/import`, formData, {
      timeout: 120000, // 2 min timeout for large imports
    });
    return response.data;
  }

  static async downloadTemplate(): Promise<void> {
    const response = await http.get(`${ENDPOINT}/import/template`, {
      responseType: 'blob',
    });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'plantilla_trabajadores.xlsx');
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  }

  static parseExcelPreview(file: File): Promise<ExcelPreviewData> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target?.result as ArrayBuffer);
          const workbook = XLSX.read(data, { type: 'array' });

          const result: ExcelPreviewData = {
            trabajadores: [],
            dependientes: [],
            direcciones: [],
            conceptos: [],
          };

          if (workbook.SheetNames.includes('TRABAJADORES')) {
            const sheet = workbook.Sheets['TRABAJADORES'];
            result.trabajadores = XLSX.utils.sheet_to_json(sheet, { defval: '' });
          }

          if (workbook.SheetNames.includes('DEPENDIENTES')) {
            const sheet = workbook.Sheets['DEPENDIENTES'];
            result.dependientes = XLSX.utils.sheet_to_json(sheet, { defval: '' });
          }

          if (workbook.SheetNames.includes('DIRECCIONES')) {
            const sheet = workbook.Sheets['DIRECCIONES'];
            result.direcciones = XLSX.utils.sheet_to_json(sheet, { defval: '' });
          }

          if (workbook.SheetNames.includes('CONCEPTOS')) {
            const sheet = workbook.Sheets['CONCEPTOS'];
            result.conceptos = XLSX.utils.sheet_to_json(sheet, { defval: '' });
          }

          resolve(result);
        } catch (err) {
          reject(err);
        }
      };
      reader.onerror = () => reject(new Error('Error al leer el archivo'));
      reader.readAsArrayBuffer(file);
    });
  }
}
